module.exports = __webpack_public_path__ + "environment-cc2d1819d380a3634e0a9256ff3c9072.png";